import {defHttp} from "xmgoing-server";
import {PageEnum} from "@/enums/pageEnum";
import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";

enum Api {
  updateDomainById= '/go-lcc/execute/updateByTableId/',
  saveDomainById = '/go-lcc/execute/saveByTableId/',
  saveDomain = '/go-lcc/execute/saveByTableCode/',
  queryDomain = '/go-lcc/execute/pageByTableCode/',
  queryDomainById = '/go-lcc/execute/pageByTableId/',
  detailDomain = '/go-lcc/execute/detailByTableCode/',
  detailDomainById= '/go-lcc/execute/detailByTableId/',
  querySubAccountList= '/pe-portal/account/listChildTenant',
  GetUserInfo = "/pe-portal/users/getUserInfo",
  queryAllAccountList= `/pe-portal/account/read_all`
}
export async function loadMesProConfigApi(params){
  return defHttp.get<any>({ url: `/xm-mes/configBop/getBopConfig`,params}, { errorMessageMode: 'none' });
}
/**
 * 加载表格信息 根据 表格id
 * @param tableId
 * @param backFun
 */
export function loadMetatableByTableId({tableId,backFun}){
  if(tableId==null||tableId===''){
    return;
  }
  const queryCommand = new QueryCommand({
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/metatable/detail',
    showTip: false,
    method: "GET"
  });
  const params = {tableId};
  queryCommand.executeQueryPromise({params}).then((des: any) => {
    backFun&&backFun(des);
  });
}

/**
 * 获取业务字段
 * @param tableId
 * @param backFun
 */
export async function loadColsByModuleTableId(tableId){
  const queryCommand = new QueryCommand({
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/execute/pageByTableCode/SYS_VISUAL_OBJECT_DETAIL',
    showTip: false,
    method: "POST"
  });
  const params = {'main_id':tableId,size:500,lccQueryScopeType:'groupAndCurrent'};
  return queryCommand.executeQueryPromise({params});
}
/**
 * 加载表格信息 所有字段
 * @param tableId
 * @param backFun
 */
export function loadMetatableAllFieldTableId({tableId,backFun}){
  const queryCommand = new QueryCommand({
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/metatable/detailAllColumn',
    showTip: false,
    method: "GET"
  });
  const params = {tableId};
  queryCommand.executeQueryPromise({params}).then((des: any) => {
    backFun&&backFun(des);
  });
}

export function addUserReplaceUrl({path,targetPath,targetName}){
  const queryCommand = new QueryCommand({
    url: SysConfigUtils.go_eplat_adress + '/api/pe-portal/resource/changeMenuPath',
    showTip: false,
    method: "POST"
  });
  const params ={path,targetPath,targetName};
  queryCommand.executeQueryPromise({params}).then((des: any) => {

  });
}

/**
 * @description: getFileList
 */
export async function saveDomainApi({domainObjs,domainCode}) {
    return defHttp.post<any>({ url: Api.saveDomain+domainCode,params:{...domainObjs} }, { errorMessageMode: 'none' });
}
export function queryAllAccountList(params: any) {
  return defHttp.post({url: Api.queryAllAccountList, params});
}

/**
 * 查询领域的集合列表信息
 * @param pageCode
 * @param current
 */
export async function loadSubAccountList({hasCurrent,pageSize,current}:any){
  const params={current,size:pageSize,hasCurrent};
  return defHttp.get<any>({ url: Api.querySubAccountList,params}, { errorMessageMode: 'none' });
}

/**
 *  查询板块列表信息
 * @param pageCode
 * @param formula
 * @param pageSize
 * @param current
 */
export async function loadAccountGroupList({pageCode,formula,pageSize,current}:any){
  const params={current,size:pageSize};
  return defHttp.get<any>({ url: Api.GetUserInfo,params}, { errorMessageMode: 'none' });
}

/**
 * 保存领域对象根据领域id
 * @param domainObjs
 * @param domainId
 */
export async function saveDomainByIdApi({domainObjs,domainId}) {
  return defHttp.post<any>({ url: Api.saveDomainById+domainId,params:{...domainObjs} }, { errorMessageMode: 'none' });
}

/**
 * 修改领域对象根据领域id
 * @param domainObjs
 * @param domainId
 */
export async function updateDomainById({domainObjs,domainId}) {
  return defHttp.post<any>({ url: Api.updateDomainById+domainId,params:{...domainObjs} }, { errorMessageMode: 'none' });
}

/**
 * 查询领域对象信息
 * @param pageCode
 * @param pageSize
 * @param current
 */
export async function queryDomainListApi({domainObjId,queryParams}){
  return defHttp.post<any>({ url: Api.queryDomainById+domainObjId,params:{...queryParams} }, { errorMessageMode: 'none' });
}

/**
 * 加载数据根据Url
 * @param url
 * @param queryParams
 * @param pageSize
 * @param current
 */
export async function loadListByUrl({url,queryParams,method,pageSize,current}:any,columns){
  const params={current,size:pageSize,...queryParams};
  url=url.replace("/api","");
  if((method+"").toUpperCase()==="GET"){
    return defHttp.get<any>({ url: url,params}, { errorMessageMode: 'none' });
  }else{
    return defHttp.post<any>({ url: url,params}, { errorMessageMode: 'none' });
  }
}

/**
 * 查询领域的集合列表信息
 * @param pageCode
 * @param current
 */
export async function loadDomainList({lccQueryScopeType,paramsRel,userDefUrl,useQueryUrl,useQueryType,pageCode,formula,pageSize,current,queryParams}:any,columns){
  let params={current};
  if(queryParams&&typeof(queryParams)==='object'){
    params={...params,...queryParams};
  }
  if(formula&&formula.length>0&&formula!==PageEnum.EMPTY_FORMULA){
    params["formula"]=formula;
  }
  if(unref(paramsRel)&&unref(paramsRel)==='or'){
    params["paramsRel"]='or';
  }
  if (lccQueryScopeType&&lccQueryScopeType!=='currentAccount') {
    params['lccQueryScopeType'] = lccQueryScopeType;
  }
  params['size']=pageSize||params['size'];
  //如果是用户启用了 指定查询地址
  if(userDefUrl&&useQueryUrl){
    useQueryUrl=useQueryUrl.replace("/api","");
    if(useQueryType==="GET"||useQueryType==="get"){
      return defHttp.get<any>({ url: useQueryUrl,params}, { errorMessageMode: 'none' });
    }else{
      return defHttp.post<any>({ url: useQueryUrl,params}, { errorMessageMode: 'none' });
    }
  }else{
    return defHttp.post<any>({ url: Api.queryDomain+pageCode,params}, { errorMessageMode: 'none' });
  }
}

/**
 * 获取领域记录的明细
 * @param pageCode
 * @param current
 */
export async function loadDomainDetail({id,pageCode}){
  return defHttp.post<any>({ url: Api.detailDomain+pageCode,params:{id} }, { errorMessageMode: 'none' });
}
/**
 * 获取领域记录的明细
 * @param pageCode
 * @param current
 */
export async function getDomainDetailById(domainObjId,recordId){
  return defHttp.post<any>({ url: Api.detailDomainById+domainObjId,params:{id:recordId} }, { errorMessageMode: 'none' });
}


export function queryPublicEvents(backFun) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/commonFunction/listEnable`,
    method: 'GET'
  });
  queryCommand.executeQuery({
    params: {}, successFun: (res) => {
      backFun&&backFun(res);
    }
  })
}


/**
 * 获取表单界面的设计信息
 * @param pageCodeVal
 */
export const loadDesInfosByCodeSev = function (pageCodeVal,backFun) {
  //获取界面id
  const queryCommand = new QueryCommand({
    method: "GET",
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/menuInfoSettingAct/detailByPageCode'
  });
  //执行查询操作
  queryCommand.executeQuery({
    params: {runType:'runing',pageCode: pageCodeVal}, successFun: (datas) => {
      backFun&&backFun(datas);
    }
  });
};

/**
 * 根据pageCode进行数据加载加载设计信息
 */
export const loadDesInfosByApi=function ({pageCodeVal,moduleCode},backFun){
  //获取界面id
  const queryCommand = new QueryCommand({
    method: "GET",
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/menuInfoSettingAct/detailByPageCode'
  });
  //执行查询操作
  queryCommand.executeQuery({
    params: {runType:'runing',pageCode: pageCodeVal, moduleCode: moduleCode || ''}, successFun: (datas) => {
      backFun&&backFun(datas);
    }
  });
}

/**
 * 根据pageCode+moduleCode进行数据加载
 * @param pageCode
 * @param moduleCode
 * @param backFun
 */
export const loadDesInfosByModuleApi = function ({pageCode, moduleCode},backFun) {
  //获取界面id
  const queryCommand = new QueryCommand({
    method: "GET",
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/customPage/getByCode'
  });
  //执行查询操作
  queryCommand.executeQuery({
    params: {pageCode: pageCode, moduleCode: moduleCode || ''}, successFun: (datas) => {
      backFun&&backFun(datas);
    }
  });
}
